import type { ApolloCache } from "@apollo/client/cache"

import { evict } from "shared/api/evict"

import { TeamMemberTypename } from "../types/TeamMember"

export function evictTeamMember(id: string, cache: ApolloCache<object>) {
  evict({ cache, id, typename: TeamMemberTypename })
}
